import { lazy } from "react";
import { Route } from "react-router-dom";

import PrivacyPolicy from "../pages/publicEnd/PrivacyPolicy";
import Terms from "../pages/publicEnd/Terms";
import ListingDetailsPage from "../components/Public/ListingDetailsPage";
import AdminForgotPassword from "../pages/auth/admin/AdminForgotPassword";
import { useSiteConfig } from "../contexts/SiteConfigContext";

const Signup = lazy(() => import("../pages/auth/Signup"));
const ActivateAccount = lazy(() =>
  import("../pages/auth/account/activate/ActivateAccount")
);
const Login = lazy(() => import("../pages/auth/Login"));
const Home = lazy(() => import("../pages/Home"));
const MapSearch = lazy(() => import("../pages/publicEnd/MapSearch"));
const ContactUs = lazy(() => import("../pages/publicEnd/ContactUs"));
const About = lazy(() => import("../pages/publicEnd/About"));
const ForgotPassword = lazy(() => import("../components/User/ForgotPassword"));
const NotFound = lazy(() => import("../pages/notFoundPages/NotFound"));

// Returns the public-facing route elements. Site-wide CMS values are read from
// SiteConfigContext rather than threaded through props from App.js.
const PublicRoutes = ({ t, i18n }) => {
  const site = useSiteConfig();
  return (
    <>
      <Route
        path="/"
        element={
          <Home
            t={t}
            i18n={i18n}
            mainPhoto={site.mainPhoto}
            mainPhotoMobile={site.mainPhotoMobile}
            pic1={site.pic1}
            pic2={site.pic2}
            mainHeading={site.mainHeading}
            mainHeadingUrdu={site.mainHeadingUrdu}
            mainSubheading={site.mainSubheading}
            mainSubheadingUrdu={site.mainSubheadingUrdu}
            heading3={site.heading3}
            heading3Urdu={site.heading3Urdu}
          />
        }
      />
      <Route path="/users/signup" element={<Signup t={t} i18n={i18n} />} />
      <Route path="/users/login" element={<Login t={t} i18n={i18n} />} />
      <Route
        path="/verify/:token"
        element={<ActivateAccount t={t} i18n={i18n} />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPassword t={t} i18n={i18n} />}
      />
      <Route
        path="/contact"
        element={
          <ContactUs
            t={t}
            i18n={i18n}
            phoneInfo={site.phoneInfo}
            phone2Info={site.phone2Info}
            emailInfo={site.emailInfo}
            addressInfo={site.addressInfo}
          />
        }
      />
      <Route
        path="/about"
        element={
          <About
            i18n={i18n}
            about={site.about}
            aboutUrdu={site.aboutUrdu}
            mainHeading={site.mainHeading}
            mainHeadingUrdu={site.mainHeadingUrdu}
            mainSubheading={site.mainSubheading}
            mainSubheadingUrdu={site.mainSubheadingUrdu}
            emailInfo={site.emailInfo}
            phoneInfo={site.phoneInfo}
          />
        }
      />
      <Route
        path="/privacy"
        element={
          <PrivacyPolicy
            i18n={i18n}
            privacy={site.privacy}
            privacyUrdu={site.privacyUrdu}
          />
        }
      />
      <Route
        path="/terms"
        element={<Terms i18n={i18n} terms={site.terms} termsUrdu={site.termsUrdu} />}
      />
      <Route
        path="/properties"
        element={
          <MapSearch
            t={t}
            i18n={i18n}
            showDetect={site.showDetect}
            showFinder={site.showFinder}
          />
        }
      />
      <Route
        path="/property-details/:slug/:id"
        element={
          <ListingDetailsPage
            termsContact={site.termsContact}
            termsContactUrdu={site.termsContactUrdu}
          />
        }
      />
      <Route
        path="/properties/:query/:status"
        element={
          <MapSearch
            t={t}
            i18n={i18n}
            showDetect={site.showDetect}
            showFinder={site.showFinder}
          />
        }
      />
      <Route
        path="/properties/status/:status"
        element={
          <MapSearch
            t={t}
            i18n={i18n}
            showDetect={site.showDetect}
            showFinder={site.showFinder}
          />
        }
      />
      <Route path="/pk/secure/admin/forgot-password" element={<AdminForgotPassword t={t} i18n={i18n} />} />
      <Route path="*" element={<NotFound t={t} />} />
    </>
  );
};

export default PublicRoutes;
